/* eslint-disable no-underscore-dangle */
import React, { useCallback, useState, useEffect } from 'react';
import axios from 'axios';
import { Amplify, Auth, Hub } from 'aws-amplify';
import CONSTANTS from './constants';
import { ReactComponent as DoneIcon } from './resources/icons/DoneIcon.svg';
import './App.css';

const App = () => {
  const [message, setMessage] = useState('');
  const [typeMessage, setTypeMessage] = useState(null);

  const authListener = useCallback(async data => {
    switch (data.payload.event) {
      case 'signIn':
        try {
          const cognitoUser = await Auth.currentAuthenticatedUser();
          const currentSession = await Auth.currentSession();
          cognitoUser.refreshSession(currentSession.refreshToken, err => {
            if (err) {
              console.log(err);
              throw err;
            }
          });
        } catch (e) {
          console.log('Unable to refresh Token', e);
        }
        break;
      case 'signIn_failure':
        setTypeMessage(CONSTANTS.ERROR);
        setMessage(`Login Failed: ${data.payload.data}`);
        break;
      default:
        break;
    }
  }, []);

  useEffect(() => {
    axios.get('/aws-exports.json').then(({ data: awsmobile }) => {
      const domain = `basikly-tampabay-${awsmobile.env}.auth.${awsmobile.region}.amazoncognito.com`;
      Amplify.configure(awsmobile);
      console.log('domain', domain);
      const oauth = {
        scope: ['email', 'aws.cognito.signin.user.admin', 'phone', 'openid'],
        redirectSignIn: `${window.location.origin}/`,
        redirectSignOut: `${window.location.origin}/`,
        responseType: 'code',
        domain,
      };
      Auth.configure({ oauth });
      const { search } = window.location;

      const getCognitoUser = () => Auth.currentAuthenticatedUser();

      const getCurrentSession = () => Auth.currentSession();

      Promise.all([getCognitoUser(), getCurrentSession()])
        .then(promiseValues => {
          const [cognitoUser, currentSession] = promiseValues;
          if (cognitoUser) {
            cognitoUser.refreshSession(currentSession.refreshToken, async err => {
              try {
                if (err) {
                  console.log(err);
                  throw err;
                }
                if (window?.__adobe_cep__) {
                  window?.__adobe_cep__?.dispatchEvent({
                    type: 'com.basikly.events.requestStoreAuth',
                    scope: 'APPLICATION',
                    appId: undefined,
                    extensionId: undefined,
                    data: JSON.stringify({ localStorage, search }),
                  });
                  window?.__adobe_cep__?.addEventListener(
                    'com.basikly.events.loginStatus',
                    event => {
                      console.log(event);
                      localStorage.clear();
                      sessionStorage.clear();
                      if (event.data) {
                        setTypeMessage(CONSTANTS.ERROR);
                        setMessage(`Login Failed: ${event.data}`);
                      } else {
                        setTypeMessage(CONSTANTS.SUCCESS);
                        setTimeout(() => {
                          window.__adobe_cep__.closeExtension();
                        }, 2000);
                      }
                    },
                  );
                } else {
                  const postUrl = `https://localhost:${awsmobile.externalAppPort}/creds`;

                  await axios.post(postUrl, {
                    localStorage,
                    search,
                  });
                  localStorage.clear();
                  sessionStorage.clear();
                  setTypeMessage(CONSTANTS.SUCCESS);
                  setTimeout(() => {
                    window.close();
                  }, 2000);
                }
              } catch (err) {
                localStorage.clear();
                sessionStorage.clear();
                setTypeMessage(CONSTANTS.ERROR);
                setMessage(`Login Failed: ${err}`);
              }
            });
          } else {
            Hub.listen('auth', authListener);
            Auth.federatedSignIn();
          }
        })
        .catch(() => {
          Hub.listen('auth', authListener);
          Auth.federatedSignIn();
        });
    });
    return () => {
      Hub.remove('auth', authListener);
    };
  }, [authListener]);

  useEffect(() => {
    console.log('window.location.href -> ', window.location.search);
  }, []);

  const renderTypeInfo = () => {
    switch (typeMessage) {
      case CONSTANTS.ERROR:
        return message;
      case CONSTANTS.SUCCESS:
        return (
          <div className="AppSuccessContainer">
            <DoneIcon style={{ width: '3rem', height: '3rem', fill: '#2196f3' }} />
            <h1>Login Successful</h1>
            <p>You have successfully signed into your account.</p>
          </div>
        );
      default:
        return null;
    }
  };

  return <div className="App">{renderTypeInfo()}</div>;
};

export default App;
